import {useRefraQuery} from '../../useRefraQuery'

export const useRefractoryClassificationsQuery = () =>
  useRefraQuery({
    queryKey: 'classifications',
    params: [],
    staleTime: Infinity
  })